import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
import DashboardLayout from '../layouts/dashboard';

import GuestGuard from '../guards/GuestGuard';
import AuthGuard from '../guards/AuthGuard';
import { PATH_AFTER_LOGIN } from '../config';
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  return (
    <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/')} />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {

  return useRoutes([
    {
      // path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <Login />
            </GuestGuard>
          ),
        },
        {
          path: 'register',
          element: (
            // <GuestGuard>
            //   <Register />
            // </GuestGuard>
            <Register />
          ),
        },
        { path: 'login-unprotected', element: <Login /> },
        { path: 'register-unprotected', element: <Register /> },
        { path: 'reset-password', element: <ResetPassword /> },
        { path: 'reset-confirm-password', element: <ResetConfirmPassword /> },
        { path: 'verify', element: <VerifyCode /> },
        { path: 'project-preview', element: <ProjectPreview /> },
      ],
    },
    // User Profile
    {
      path: '/:userId',
      children: [
        {
          path: '',
          element: <LocationDetailsPage />,
        },
      ],
    },
    {
      // path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'profile', element: <ProfilePageMain /> },
        {
          path: 'setting',
          element: <SettingPageMain />,
        },
        {
          path: 'contacts',
          element: <MyContactPageMain />,
        },
        {
          path: 'dashboard',
          element: <GeneralApp />,
        },
        {
          path: 'search',
          children: [
            { element: <Navigate to="/search/talentSearch" replace />, index: true },
            { path: 'talentSearch', element: <TalentSearchMains /> },
            { path: 'talentSearchResult/:flag/:searchParameters', element: <ListOfTalent /> },
            { path: 'talentSearchMain/:flag/:searchId/:searchParameters', element: <SavedSearchShow /> },
          ],
        },
        {
          path: 'network',
          children: [
            { path: 'followers', element: <Followers /> },
            { path: 'following', element: <Following /> },
            { path: 'mynetwork', element: <MyNetwork /> },
            { path: 'network', element: <Network /> },
            { path: 'myinvitation', element: <MyInvitation /> },
          ],
        },   
        { path: 'calendar', element: <CalendarMain /> },
        {
          path: 'inbox',
          children: [
            { path: '', element: <Inbox /> },
            { path: 'notification', element: <Notifications /> },
            { path: 'enquiry', element: <Enquiry /> },
          ],
        },
        { path: 'website', element: <WebsiteAboutUs /> },
        { path: 'subscription', element: <Subscription /> },
      ],
    },
    {
      path: '/',
      element: <Login />,
      children: [{ element: <HomePage />, index: true }],
    },
    { path: '*', element: <Navigate to="/" replace /> },
  ]);
}

// IMPORT COMPONENTS
// Authentication
const Login = Loadable(lazy(() => import('../pages/auth/Login')));
const Register = Loadable(lazy(() => import('../pages/auth/Register')));
const ResetPassword = Loadable(lazy(() => import('../pages/auth/ResetPassword')));
const ResetConfirmPassword = Loadable(lazy(() => import('../pages/auth/ResetConfirmPass')));
const VerifyCode = Loadable(lazy(() => import('../pages/auth/VerifyCode')));
// Dashboard
const GeneralApp = Loadable(lazy(() => import('../pages/dashboard/GeneralApp')));
const UserProfile = Loadable(lazy(() => import('../pages/dashboard/UserProfile')));
const PortFolio = Loadable(lazy(() => import('../pages/ComingSoon')));
// Main
const HomePage = Loadable(lazy(() => import('../pages/Home')));
const NotFound = Loadable(lazy(() => import('../pages/Page404')));
const LocationDetailsPage = Loadable(lazy(() => import('../pages/dashboard/LocationDetails')));
const SettingPageMain = Loadable(lazy(() => import('../pages/dashboard/SettingPage')));
const MyContactPageMain = Loadable(lazy(() => import('../pages/dashboard/MyContact')));
const CalendarMain = Loadable(lazy(() => import('../pages/dashboard/Calendar')));
const ProfilePageMain = Loadable(lazy(() => import('../pages/dashboard/EmployerPage')));
const TalentSearchMains = Loadable(lazy(() => import('../pages/dashboard/TalentSearchPage')));
const ListOfTalent = Loadable(lazy(() => import('../sections/@dashboard/user/profile/SavedTalentAdvancedSearch')));
const SavedSearchShow = Loadable(lazy(() => import('../sections/@dashboard/user/profile/SavedTalentAdvancedSearch')));
const Followers = Loadable(lazy(() => import('../pages/dashboard/connectnetwork/Followers')));
const Following = Loadable(lazy(() => import('../pages/dashboard/connectnetwork/Following')));
const Network = Loadable(lazy(() => import('../pages/dashboard/connectnetwork/Network')));
const MyNetwork = Loadable(lazy(() => import('../pages/dashboard/connectnetwork/MyNetwork')));
const MyInvitation = Loadable(lazy(() => import('../pages/dashboard/connectnetwork/MyInvitation')));
const WebsiteAboutUs = Loadable(lazy(() => import('../pages/dashboard/Website/AboutUs')));
const Inbox = Loadable(lazy(() => import('../pages/dashboard/InBox/JobInbox')));
const Subscription = Loadable(lazy(() => import('../pages/dashboard/InBox/Subscription')));
const Notifications = Loadable(lazy(() => import('../pages/dashboard/InBox/Notifications')));
const Enquiry = Loadable(lazy(() => import('../pages/dashboard/InBox/Enquiry')));
const ProjectPreview = Loadable(lazy(() => import('../pages/dashboard/PreviewProject')));



